import FlyerMakerHeader from './Misc/FlyerMakerHeader';
import Navbar from './Misc/NavBar';

export default function FlyerMakerLayout({ children }) {
  return (
    <div className="App" style={{fontFamily: 'Trade Gothic'}}>
      <FlyerMakerHeader />
      <Navbar />
      {children}
    </div>
  );
}
